"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _ItemSelectContext = require("./ItemSelectContext");

var _classNames = _interopRequireDefault(require("../../util/classNames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useItemSelect = function useItemSelect(props) {
  var _useContext = (0, _react.useContext)(_ItemSelectContext.Context),
      _useContext2 = _slicedToArray(_useContext, 4),
      currentItem = _useContext2[0],
      setCurrentItem = _useContext2[1],
      askForConfirmation = _useContext2[2],
      setBeforeState = _useContext2[3];

  var _useState = (0, _react.useState)(props.checked),
      _useState2 = _slicedToArray(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  var onClick = function onClick() {
    if (!props.disabled && !checked) {
      if (askForConfirmation) {
        setBeforeState(props.id);
      } else {
        setChecked(true);
      }
    }
  }; //para darle estilos a los items


  var classes = (0, _classNames["default"])({
    disabled: props.disabled,
    active: props.disabled ? false : checked
  });
  (0, _react.useEffect)(function () {
    //cada que el item cambia checar si es el activo
    if (checked) {
      currentItem !== props.id && setChecked(false);
    } else {
      currentItem === props.id && setChecked(true);
    }
  }, [currentItem]);
  (0, _react.useEffect)(function () {
    if (checked && currentItem !== props.id) {
      setCurrentItem(props.id);
    }
  }, [checked]);
  return [onClick, classes];
};

var _default = useItemSelect;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/hooks/itemSelect/useItemSelect.js
// module id = 426
// module chunks = 0